import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["roomCheckbox"];

  selectAll() {
    this.roomCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true;
    });
  }

  clearAll() {
    this.roomCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
}
